/**
 * shim implementation taken from https://developers.google.com/web/updates/2015/08/using-requestidlecallback
 */
const requestIdleFallback = (
  cb: (deadline: RequestIdleCallbackDeadline) => void
) => {
  const start = Date.now();
  return window.setTimeout(() => {
    // eslint-disable-next-line n/no-callback-literal
    cb({
      didTimeout: false,
      timeRemaining: () => {
        return Math.max(0, 50 - (Date.now() - start));
      },
    });
  }, 1);
};

/**
 * TODO: https://aboutyou.atlassian.net/browse/ASFE-12360
 *
 * Remove the timeout after fixing the performance issues on the product slider zoom
 *
 * The timeout in the requestIdleCallback function forces to execute callbacks that are
 * indefinitely delayed. This is added because the submit feature tracking event on the video slide
 * does not fire after 5 secs since the product zoom component blocks the main thread
 * the reason is the use of the useGesture library for the zoom.
 * */
export const doAsync = (
  callback: (deadline: RequestIdleCallbackDeadline) => void
): RequestIdleCallbackHandle => {
  if ('requestIdleCallback' in window) {
    return window.requestIdleCallback!(callback, {
      timeout: 500,
    });
  } else {
    return requestIdleFallback(callback);
  }
};
